import lodashGet from 'lodash/get';

export const isTooManySublocationsError = error =>
  lodashGet(error, ['response', 'data', 'errors', 0, 'code']) === '107';
